
// Represents the Course record in database
export interface Course {
	id: number,
	name: string,
	description: string,
	visible: boolean,
	thumbnail: string,
	lessons: Lesson[] | null
}

// Represents course with user information
export interface UserCourseDTO {
	id: number,
	name: string,
	description: string,
    thumbnail: string,
    category: string,
    prerequisiteId: number | null,
    prerequisiteName: string | null,
    prerequisiteComplete: boolean,
	status: CourseStatus,
	userCourseResultId: number,
	startedOn: Date | null,
	completedOn: Date | null,
	grade: number,
    lessons: UserLessonDTO[] | null,
    tags: string[] | null,
	totalLessons: number,
	completedLessons: number,
	trainingAddress: string
}

export interface Lesson {
	id: number,
	name: string,
	description: string,
	order: number,
	type: LessonType,
	videoURL: string,
	passingGrade: number
}

export interface UserLessonDTO {
	id: number,
	name: string,
	description: string,
    order: number,
    duration: number,
	passingGrade: number,
	userLessonResultId: number,
	steps: LessonStep[],
	stepsComplete: string,
	startedOn: Date | null,
	quizStart: Date | null,
	quizEnd: Date | null,
	quizPercent: number
}

export interface LessonStep {
	id: number,
	name: string,
	order: number,
	type: LessonType,
	videoURL: string,
    content: string
    hardwareType: HardwareType | null,
    hardwareAction: HardwareAction | null,
    hardwareValue: string | null
    quizQuestions: QuizQuestion[]
}

export interface QuizQuestion {
    id: number,
    question: string,
    answer: string,
    type: QuestionType,
    order: number,
    wrongAnswer1: string | null,
    wrongAnswer2: string | null,
    wrongAnswer3: string | null
    key: number | null
}

export interface CourseMetadata {
    tags: string[],
    categories: string[]
}

export enum LessonType {
	Video,
	Software,
	Hardware
}

export enum CourseStatus {
	New,
	InProgress,
	Pass,
	Expired
}

export enum QuestionType {
    MultipleChoice,
    TrueFalse,
    Textarea
}

export enum HardwareType {
    POE,
    PRSMaster,
    PRS8DR,
    PRSElevator,
    PRSIO
}

export enum HardwareAction {
    EnterInfoMenu,
    ViewPanelMAC,
    ViewActualIP,
    EnterConfigMenu,
    SetServerIP,
    SetServerPort,
    SetServerName,
    SetServerConnMode,
    SetPanelCommMode,
    SetPanelIPAddr,
    SetPanelSubnet,
    SetPanelGateway,
    SetPanelDNS,
    SetPanelRunMode,
    PingIP,
    PingName,
    OutputTest,
    InputTest,
    ReaderTest,
    ReaderSampling,
    DeleteEvents,
    EraseFlash
}